/**
 * Phone numbers are stored exactly as the realtor typed them — "+380 50 123
 * 45 67", "0501234567", "050-123-45-67" — so a search has to compare digits,
 * not text. DynamoDB's contains() can't do that, which is why both filter
 * bars match phones in the browser.
 */

/**
 * Only the digits, with Ukraine's country code folded into the local form:
 * "+380 50 123 45 67" and "050 123 45 67" both become "0501234567".
 */
export function phoneDigits(value) {
  var digits = String(value == null ? "" : value).replace(/\D/g, "");
  if (digits.indexOf("380") === 0) digits = digits.slice(2);
  return digits;
}

/**
 * Does a stored number match what was typed? A partial number matches
 * anywhere inside ("123 45" finds "050 123 45 67"); an empty query matches
 * everything, so callers need no guard.
 */
export function phoneMatches(stored, query) {
  var wanted = phoneDigits(query);
  if (wanted.length === 0) return true;
  return phoneDigits(stored).indexOf(wanted) !== -1;
}
